export default __webpack_public_path__ + "static/media/fishmarket3_05.fed21d88.png";